import { Injectable } from '@angular/core';
import { transformObservableToSinglePromise } from '../helpers/angular-helpers';
import { apiLink } from 'src/app/helpers/app-constants';
import { ClipboardTab, CreateEntitiesFromTemplatesData, CreateEntityTemplatesData } from 'globals/store/entity.data';
import { LogService } from './log.service';
import { HttpClient } from '@angular/common/http';
import { Entity } from 'globals/store/entity.data';
import { EventService } from 'src/app/services/event.service';
import { ImageType } from 'globals/store/files.model';
import { AccountClipboardPage, createNewAdminPageGenerator, EntityClipboard } from 'globals/store/accounts.data';
import { deleteFromPages, updateInPages } from 'globals/store/pages.data';
import { environment } from '../../environments/environment';
import { Dictionary } from '@ngrx/entity';
import * as firebase from 'firebase/app';
import { deleteField, doc, Firestore, runTransaction, Transaction } from '@angular/fire/firestore';

@Injectable({ providedIn: 'root' })
export class EntitiesService {
  readonly _file = 'entities.service.ts'
  constructor(private log: LogService, 
    private db: Firestore,
    private http: HttpClient, private eventService: EventService) {}


  async duplicateTemplates(type: ImageType, templates: Entity[], accountId: string) {
    const data: CreateEntityTemplatesData = { type, entities: templates, accountId }
    return await this.postNewTemplates(data)
  }

  private async postNewTemplates(data: CreateEntityTemplatesData) {
    // console.log({ data })
    const promise = transformObservableToSinglePromise<Entity[]>(this.http.post(`${apiLink}/create-entity-templates`, data))
    const newEntities = await this.log.executePromiseLogError(this, promise, 'createEntityTemplates', `There was an error creating ${data.type} templates`) as Entity[]
    console.log({ newEntities })
    return newEntities
  }

  async createEntityTemplates(type: ImageType, entities: Entity[]) {
    console.log("Templating... " + type, entities)
    if (!entities.length) return
    const event = await this.eventService.getCurrentEvent()
    const data: CreateEntityTemplatesData = { type, entities, eventId: event.eventId, accountId: event.accountId, eventName: event.title || '' }
    return await this.postNewTemplates(data)
  }
  
  async deleteTemplates(type: keyof EntityClipboard, ids: string[], clipboardPages: AccountClipboardPage[]) {
    const updates = deleteFromPages(clipboardPages, type, ids, deleteField)
    console.log({ updatesWithDeletions: updates })
    runTransaction(this.db, async (transaction) => {
      this.updateTemplates(updates, transaction)
    })
  }

  private async updateTemplates(updates: Dictionary<Partial<AccountClipboardPage>>, transaction: Transaction) {
    Object.entries(updates).forEach(([pageId, update]) => {
      transaction.update(doc(this.db, `clipboards/${pageId}`), update)
    })
  }

  async saveTemplate(type: keyof EntityClipboard, entity: Entity, accountId: string, clipboardPages: AccountClipboardPage[]) {
    entity.dateModified = new Date().getTime();
    const { changes, newPages } = updateInPages<AccountClipboardPage, typeof type, typeof entity>(clipboardPages, type, [entity], createNewAdminPageGenerator(accountId), environment.MAX_PAGE_SIZE, deleteField)
    console.log({ changes, newPages })
    await runTransaction(this.db, async (transaction) => {
      newPages.forEach(page => { // should just be one new page here at most, of course, but updateInPages is more general than that
        console.log({ newPage: page })
        const ref = doc(this.db, "clipboards", page.id)
        page.id = ref.id
        transaction.set(ref, page)
      })
      this.updateTemplates(changes, transaction)
    })
  }

  async createEntitiesFromTemplates(type: ImageType, entities: Entity[]) {
    const event = await this.eventService.getCurrentEvent()
    const data: CreateEntitiesFromTemplatesData = { type, ids: entities.map(e => e.templateId), eventId: event.eventId, accountId: event.accountId }
    console.log(data)
    const promise = transformObservableToSinglePromise<Entity[]>(this.http.post(`${apiLink}/create-entities-from-templates`, data))
    return await this.log.executePromiseLogError(this, promise, 'createEntitiesFromTemplates', `There was an error creating ${data.type} from templates`) as Entity[]
  }
}